import { Avatar, Skeleton, SkeletonItem } from "@fluentui/react-components";
import HoverCard from "../../components/hoverCard/HoverCard";
import { BriefcaseIcon, CurrencyIcon, PersonIcon } from "../../modules/default-svg";
import { useHistory } from "react-router-dom";
import useNavigation from "../../utils/useNavigation";
import ResourceDetails from "../resourcePlanner/resourceDetails/ResourceDetails";
import Modal from "../../components/controls/modal/Modal";
import { useEffect, useState } from "react";
import { apiInstance, routes } from "../../helpers/API";
import { useDispatch } from "react-redux";
import { generalActions } from "../../store/actions";
import SafeHtml from "../../components/safeHtml/SafeHtml";
import { getAccountCurrency, displayDecimalFormatted } from "../../utils/systemSettings";
import TeamManagement from "../../components/teamManagement/TeamManagement";
import clientService from "../../store/services/clients.service";
import portfolioService from "../../store/services/portfolio.service";
import programService from "../../store/services/programs.service";

const Details = (props) => {
  const { data, type } = props;
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const displatch = useDispatch();
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isResourceDetailsLoading, setIsResourceDetailsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(false);
  const [resourceProjects, setResourceProjects] = useState([]);
  const [resourceTasks, setResourceTasks] = useState([]);
  const [resources, setResources] = useState({});
  const [activeTab, setActiveTab] = useState("byProject");

  const setting = JSON.parse(localStorage.getItem("settings"));
  const handleRedirection = (type, id, name) => {
    switch (type) {
      case "Client": {
        navigateTo("Clients", id, data.client.name);
        break;
      }
      case "Portfolio": {
        navigateTo("Portfolios", id, data.portfolio.name);
        break;
      }
      case "Program": {
        navigateTo("Programs", id, data.program.name);
        break;
      }
      case "Project": {
        navigateTo("Projects", id, name);
        break;
      }
      default:
        return "";
    }
  };

  const fetchResources = (type, id) => {
    setIsLoading(true);
    switch (type.toLowerCase()) {
      case "client":
        clientService.getTeam(id)
          .then((response) => {
            setResources(response);
            setIsLoading(false);
          }
          )
          .catch((error) => { })
          .finally(() => {
            setIsLoading(false);
          });
        break;
      case "portfolio":
        portfolioService.getTeam(id)
          .then((response) => {
            setResources(response);
            setIsLoading(false);
          }
          )
          .catch((error) => { })
          .finally(() => {
            setIsLoading(false);
          });
        break;
      case "program":
        programService.getTeam(id)
          .then((response) => {
            setResources(response);
            setIsLoading(false);
          }
          )
          .catch((error) => { })
          .finally(() => {
            setIsLoading(false);
          });
        break;
    }
  };

  useEffect(() => {
    if (data?.id && type) {
      fetchResources(type, data.id);
    }
  }, [data, type]);

  const getResourceContribution = async (resourceId) => {
    try {
      setIsResourceDetailsLoading(true);
      const response = await apiInstance.get(
        `${routes.getContribution.replace(":resourceId", resourceId)}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage
              ?.getItem("accessToken")
              ?.replace(/"/g, "")}`,
          },
          params:
            type === "Client"
              ? {
                ClientId: data.id,
              }
              : type === "Portfolio"
                ? {
                  PortfolioId: data.id,
                }
                : type === "Program"
                  ? {
                    ProgramId: data.id,
                  }
                  : null,
        }
      );
      const {
        data: { resource, allocatedCapacity, totalCapacity, projects, tasks },
      } = response;
      setIsResourceDetailsLoading(false);
      setUserDetails({ ...resource, allocatedCapacity, totalCapacity });
      setResourceProjects(projects.length > 0 ? projects : []);
      setResourceTasks(tasks.length > 0 ? tasks : []);
    } catch (error) {
      setIsResourceDetailsLoading(false);
      return displatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    }
  };

  const handleCancel = () => setShowDetailModal(false);
  const handleOpen = (user) => {
    setUserDetails(user);
    setShowDetailModal(true);
    getResourceContribution(user.id);
  };

  const handleTeamUpdate = () => {
    fetchResources(type, data.id);
  };

  return (
    <div className="DetailsTabScroll">
      <div className="row">
        {data && (
          <>
            <div className="col-lg-8">
              <div className="CustomCard p-4">
                {data.refId && <p className="detailBadge">{data.refId}</p>}
                <h5 className="mb-12">{data.name}</h5>
                {type !== "Client" && (
                  <>
                    <div className="detailsInfoWrap">
                      <div className="col-3">
                        <div className="d-flex align-items-centers">
                          <span className="me-2 d-inline-flex">
                            <PersonIcon />
                          </span>
                          <p className="text-md-400 grey46Color">Client</p>
                        </div>
                      </div>
                      <div className="col-9">
                        {data && (
                          <p
                            className={`text-md-400 grey10Color ${data.client && "entityName"
                              }`}
                            onClick={() =>
                              data.client
                                ? handleRedirection("Client", data?.client?.id)
                                : null
                            }
                          >
                            {data.client ? data.client.name : ""}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="detailsInfoWrap">
                      <div className="col-3">
                        <div className="d-flex align-items-center">
                          <span className="me-2 d-inline-flex">
                            <BriefcaseIcon />
                          </span>
                          <p className="text-md-400 grey46Color">Portfolio</p>
                        </div>
                      </div>
                      <div className="col-9">
                        <p
                          className={`text-md-400 grey10Color ${data.portfolio && "entityName"
                            }`}
                          onClick={() =>
                            data.portfolio
                              ? handleRedirection(
                                "Portfolio",
                                data?.portfolio?.id
                              )
                              : null
                          }
                        >
                          {data.portfolio ? data.portfolio.name : "--"}
                        </p>
                      </div>
                    </div>
                    <div className="detailsInfoWrap">
                      <div className="col-3">
                        <div className="d-flex align-items-center">
                          <span className="me-2 d-inline-flex">
                            <CurrencyIcon />
                          </span>
                          <p className="text-md-400 grey46Color">Budget</p>
                        </div>
                      </div>
                      <div className="col-9">
                        <p className="text-md-400 grey10Color">
                          {data.budget
                            ? `${getAccountCurrency(
                              setting
                            )}${displayDecimalFormatted(
                              setting,
                              data.budget
                            )}`
                            : ""}
                        </p>
                      </div>
                    </div>
                  </>
                )}
                <Description type={type} data={data} />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="CustomCard p-4">
                <div className={`d-flex justify-content-between align-items-center mb-20`}>
                  <div className={`d-flex align-items-center gap-2`}>
                    <h4 className="mb-0">Team</h4>

                    {/* Tabs - Only show for Client */}
                    {type.toLowerCase() === "client" ? (
                      <div className="resourcesTabToggleContainer">
                        <button
                          className={`resourcesTabToggleButton ${activeTab === "byProject" ? "active" : ""}`}
                          onClick={() => setActiveTab("byProject")}
                        >
                          By Project
                        </button>
                        <button
                          className={`resourcesTabToggleButton ${activeTab === "all" ? "active" : ""}`}
                          onClick={() => setActiveTab("all")}
                        >
                          All
                        </button>
                      </div>
                    ) :
                      (
                        <div className="resourcesTabToggleContainer">
                          <span
                            className={`resourcesTabProject`}
                          >
                            By Project
                          </span>
                        </div>
                      )}
                  </div>

                  {type.toLowerCase() === "client" && (
                    <div>
                      {isLoading ? (
                        <Skeleton>
                          <SkeletonItem style={{ width: "100px", height: "30px", borderRadius: "20px" }} />
                        </Skeleton>
                      ) : (
                        <TeamManagement
                          entityType={type.toLowerCase()}
                          entityId={data.id}
                          onTeamUpdate={handleTeamUpdate}
                          initialTeamUsers={resources ? resources.resources : []}
                        />
                      )}
                    </div>
                  )}
                </div>

                {isLoading ? (
                  [...Array(5)].map((_, index) => (
                    <div key={index} className="d-flex align-items-center CustomCardWrap pl-2 mb-3">
                      <Skeleton>
                        <SkeletonItem size={32} shape="circle" />
                      </Skeleton>
                      <div className="ms-12 flex-grow-1">
                        <Skeleton>
                          <SkeletonItem style={{ width: '60%', height: '20px' }} />
                        </Skeleton>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    {type.toLowerCase() === "client" ? (
                      <>
                        {activeTab === "byProject" ? (
                          // By Project View
                          resources && resources.resourcesByProject ? (
                            [...resources.resourcesByProject].sort((a, b) => (a.project.name || '').localeCompare(b.project.name || '')).map((item) => (
                              <div key={item.project.id} className="bg-[#f9f8ff] rounded-lg p-3 mb-3">
                                <p
                                  className="text-[13px] text-[#342c82] font-figtree font-semibold mb-2 hover:font-bold cursor-pointer"
                                  onClick={() => handleRedirection("Project", item.project.id, item.project.name)}
                                >
                                  {item.project.name}
                                </p>
                                {[...item.users].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map((user) => (
                                  <div
                                    className="d-flex align-items-center CustomCardWrap pl-2"
                                    key={user.id}
                                  >
                                    <HoverCard
                                      HoverCardTrigger={
                                        <Avatar
                                          color="colorful"
                                          size={28}
                                          name={user.name}
                                          image={{ src: user.image ? user.image : "" }}
                                        />
                                      }
                                      AvatarId={user.id}
                                      AvatarName={user.name}
                                      AvatarImage={user.image}
                                      AvatarDesignation={user.title}
                                      AvatarEmail={user.email}
                                      AvatarPhone={user.phoneNumber}
                                      AvatarIsExternal={user.isExternal}
                                    />
                                    {/* <div className="ms-12 hover:font-bold hover:underline cursor-pointer" onClick={() => handleOpen(user)}>
                                      <p className="mb-1 textColor3">{user.name}</p>
                                    </div> */}
                                    <div className="ms-12 resourceNameContainer">
                                      <span className="resourceName">{user.name}</span>
                                      {user?.title && <span className="resourceTitle">{user.title}</span>}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))
                          ) : (
                            <div className="text-center py-4 text-gray-500">
                              <p className="text-sm">No resources assigned by project</p>
                            </div>
                          )
                        ) : (
                          // All View
                          resources && resources.resources ? (
                            [...resources.resources].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map((user) => (
                              <div
                                className="d-flex align-items-center CustomCardWrap pl-2"
                                key={user.id}
                              >
                                <HoverCard
                                  HoverCardTrigger={
                                    <Avatar
                                      color="colorful"
                                      size={28}
                                      name={user.name}
                                      image={{ src: user.image ? user.image : "" }}
                                    />
                                  }
                                  AvatarId={user.id}
                                  AvatarName={user.name}
                                  AvatarImage={user.image}
                                  AvatarDesignation={user.title}
                                  AvatarEmail={user.email}
                                  AvatarPhone={user.phoneNumber}
                                  AvatarIsExternal={user.isExternal}
                                />
                                {/* <div className="ms-12 hover:font-bold hover:underline cursor-pointer" onClick={() => handleOpen(user)}>
                                  <p className="mb-1 textColor3">{user.name}</p>
                                </div> */}
                                <div className="ms-12 resourceNameContainer">
                                  <span className="resourceName">{user.name}</span>
                                  {user?.title && <span className="resourceTitle">{user.title}</span>}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-center py-4 text-gray-500">
                              <p className="text-sm">No team members yet</p>
                            </div>
                          )
                        )}
                      </>
                    ) : (
                      // Non-client view (Portfolio/Program) - unchanged
                      resources && resources.resourcesByProject &&
                      [...resources.resourcesByProject].sort((a, b) => (a.project.name || '').localeCompare(b.project.name || '')).map((item) => (
                        <div key={item.project.id} className="bg-[#f9f8ff] rounded-lg p-3 mb-3">
                          <p
                            className="text-[13px] text-[#342c82] font-figtree font-semibold mb-2 hover:font-bold cursor-pointer"
                            onClick={() => handleRedirection("Project", item.project.id, item.project.name)}
                          >
                            {item.project.name}
                          </p>
                          {[...item.users].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map((user) => (
                            <div
                              className="d-flex align-items-center CustomCardWrap pl-2"
                              key={user.id}
                            >
                              <HoverCard
                                HoverCardTrigger={
                                  <Avatar
                                    color="colorful"
                                    size={28}
                                    name={user.name}
                                    image={{ src: user.image ? user.image : "" }}
                                  />
                                }
                                AvatarId={user.id}
                                AvatarName={user.name}
                                AvatarImage={user.image}
                                AvatarDesignation={user.title}
                                AvatarEmail={user.email}
                                AvatarPhone={user.phoneNumber}
                                AvatarIsExternal={user.isExternal}
                              />
                              {/* <div className="ms-12 hover:font-bold hover:underline cursor-pointer" onClick={() => handleOpen(user)}>
                                <p className="mb-1 textColor3">{user.name}</p>
                              </div> */}
                              <div className="ms-12 resourceNameContainer">
                                <span className="resourceName">{user.name}</span>
                                {user?.title && <span className="resourceTitle">{user.title}</span>}
                              </div>
                            </div>
                          ))}
                        </div>
                      ))
                    )}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      {showDetailModal && (
        <Modal
          title="Resource Details"
          footer={false}
          handleCancel={() => handleCancel(false)}
          handleSave={() => handleCancel(false)}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={false}
          size="large"
          calendarModalWrap={true}
          body={
            <ResourceDetails
              isLoading={isResourceDetailsLoading}
              userDetails={userDetails}
              shift={null}
              projects={resourceProjects}
              tasks={resourceTasks}
              isProjects={true}
              isTasks={true}
              defaultTab="projects"
            />
          }
        />
      )}
    </div>
  );
};
export default Details;


const Description = ({ type, data }) => {
  var title, text, isHtml = true;
  switch (type) {
    case "Client":
      title = "Notes";
      text = data.notes;
      break;
    case "Portfolio":
      title = "Description";
      text = data.description;
      break;
    case "Program":
      title = "Objectives";
      text = data.objectives;
      break;
  }

  return (
    (text &&
      <div style={{ borderBottom: "1px solid #ebebeb" }}>
        <h6 className="font-weight-600 grey46Color my-3"> {title} </h6>
        <p className="text-md-400 BaseMainColor mb-12" style={{ whiteSpace: "pre-line" }}>
          {isHtml ? <SafeHtml html={text} /> : text}
        </p>
      </div>
    )

  );
}
